import React from "react"
import Navbar from "../bootstrap/navbar"
import Container from "../bootstrap/container"
import DmaeLogo from "./sub-nav-dmae"
import Social from "./sub-nav-social"

const SubNavEmpty = props => {

  return (
    <Navbar
      id="nav-sub"
      bg="lsu-light-purple"
      variant="dark"
      expand={true}
    >
      <Container>
        <DmaeLogo/>
       <Social followUs={true}/>
        
      </Container>
    </Navbar>
  )
}
export default SubNavEmpty
